import React, { useEffect, useRef } from "react";
import cssClasses from "./ContactUs.module.css";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";

import Call from "../../Assets/Images/Common/ContactCall.svg";
import Chat from "../../Assets/Images/Common/ContactChat.svg";
import Visit from "../../Assets/Images/Common/ContactVisit.svg";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function ContactUs() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(actions.activeMenu("help"));
	}, []);
	return (
		<div className={cssClasses.wrapperPage}>
			<div className={cssClasses.title}>Contact Us</div>
			<div className={cssClasses.mainContent}>
				<div className={cssClasses.contentBody}>
					<div className={cssClasses.subBranch}>CORPORATE OFFICE</div>
					<Grid
						container
						spacing={{ xs: 2, md: 3, sm: 4 }}
						columns={{ xs: 4, sm: 8, md: 12 }}
						sx={{ flexDirection: { xs: "column", md: "row" } }}
					>
						<Grid item xs={12} sm={8} md={4}>
							<div className={cssClasses.cardData}>
								<img src={Chat} alt="chat" />
								<div className={cssClasses.contactMainData}>
									<div className={cssClasses.contactFirstData}>
										<div className={cssClasses.subTitle}> Chat to sales </div>
										<div className={cssClasses.content}>Speak to our friendly team.</div>
									</div>
									<div className={cssClasses.contentData}>enquiry@javdekars.com</div>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={8} md={4}>
							<div className={cssClasses.cardData}>
								<img src={Visit} alt="vist" />
								<div className={cssClasses.contactMainData}>
									<div className={cssClasses.contactFirstData}>
										<div className={cssClasses.subTitle}>Visit Us</div>
										<div className={cssClasses.content}>Visit our office HQ.</div>
									</div>
									<div className={cssClasses.contentData}>306, Siddharth Towers, Sangam Press Road, Kothrud, Pune 411 038</div>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={8} md={4}>
							<div className={cssClasses.cardData}>
								<img src={Call} alt="call" />
								<div className={cssClasses.contactMainData}>
									<div className={cssClasses.contactFirstData}>
										<div className={cssClasses.subTitle}>Call Us</div>
										<div className={cssClasses.content}>24*7 Availability</div>
									</div>
									<div className={cssClasses.contentData}>+91 20 6764 8000 / 01 / 02</div>
								</div>
							</div>
						</Grid>
					</Grid>
				</div>
				<div className={cssClasses.contentBody}>
					<div className={cssClasses.subBranch}>BRANCH OFFICE</div>
					<Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ flexDirection: { xs: "column", md: "row" } }}>
						<Grid item xs={12} sm={8} md={4}>
							<div className={cssClasses.cardData}>
								<img src={Chat} alt="chat" />
								<div className={cssClasses.contactMainData}>
									<div className={cssClasses.contactFirstData}>
										<div className={cssClasses.subTitle}> Chat to sales </div>
										<div className={cssClasses.content}>Speak to our friendly team.</div>
									</div>
									<div className={cssClasses.contentData}>enquiry@javdekars.com</div>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={8} md={4}>
							<div className={cssClasses.cardData}>
								<img src={Visit} alt="vist" />
								<div className={cssClasses.contactMainData}>
									<div className={cssClasses.contactFirstData}>
										<div className={cssClasses.subTitle}>Visit Us</div>
										<div className={cssClasses.content}>Visit our office HQ.</div>
									</div>
									<div className={cssClasses.contentData}>
										Centro Mall, 5th Floor, Next to Palash Plus Apartments, Opposite Euro School, Wakad, Pune 411057
									</div>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={8} md={4}>
							<div className={cssClasses.cardData}>
								<img src={Call} alt="call" />
								<div className={cssClasses.contactMainData}>
									<div className={cssClasses.contactFirstData}>
										<div className={cssClasses.subTitle}>Call Us</div>
										<div className={cssClasses.content}>24*7 Availability</div>
									</div>
									<div className={cssClasses.contentData}>020 6764 8080</div>
								</div>
							</div>
						</Grid>
					</Grid>
				</div>
			</div>
		</div>
	);
}
